export default __webpack_public_path__ + "static/media/about-header-image-mobile.c9e7f744.png";